export default __webpack_public_path__ + "static/2.5.4/media/editInstitutionSettingsLogo.b8592cd0.svg";